import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ContainedButton, Dialog, OutlinedButton } from '@shared/components';
import { useCalculusTFunction } from '@retail/calculus/i18n';

interface Props {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export function CombinedViewIntroDialog({ open, onAccept, onDecline }: Props) {
  const t = useCalculusTFunction();

  return (
    <Dialog open={open} onClose={onDecline} maxWidth="xs">
      <DialogTitle>{t('calculus.combinedView.introTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('calculus.combinedView.introDescription')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <OutlinedButton onClick={onDecline}>{t('calculus.combinedView.decline')}</OutlinedButton>
        <ContainedButton onClick={onAccept}>{t('calculus.combinedView.accept')}</ContainedButton>
      </DialogActions>
    </Dialog>
  );
}
